import { Injectable, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { selectAppConfig, selectAppError, selectTimezone, selectTimezonesList, selectUser } from "./state/core.selector";
import { MenuService } from "./services/menu.service";
import { Observable, of } from "rxjs";
import { CoreActions, CoreApiActions } from "./state/core.action";
import { CoreState } from "./state/core.reducer";
import { Subscription } from 'rxjs';
import { MenuItem } from "primeng/api";
import { AppService } from "./services/app.service";
import { TimezoneAppItemOutputDto } from "@shared/api/model/timezone-app-item-output-dto";


@Injectable()
export class CoreFacade implements OnDestroy {

    public static storageTimezoneKey = "appTimezone";

    public static intlsupportedZones = Intl.supportedValuesOf('timeZone');

    error$ = this.store.select(selectAppError);
    user$ = this.store.select(selectUser);
    appConfig$ = this.store.select(selectAppConfig);
    timezone$ = this.store.select(selectTimezone);
    timezonesList$ = this.store.select(selectTimezonesList);

    menuItems$: Observable<MenuItem[]> = of([]);
    userItems$: Observable<MenuItem[]> = of([]);

    private subscriptions: Subscription[] = [];

    constructor(
        private store: Store<CoreState>,
        private menuService: MenuService,
        private appService: AppService
    ) { }

    // Init store
    init() {
        this.store.dispatch(CoreActions.init());
        this.store.dispatch(CoreApiActions.loadAppConfig());
    }

    // Load menu items
    loadMenuItems() {
        this.store.dispatch(CoreApiActions.loadMenuItems());
        this.menuItems$ = this.menuService.getMenuItems();
        this.userItems$ = this.menuService.getUserItems();
        this.store.dispatch(CoreApiActions.loadMenuItemsSuccess());
    }

    // Get current user
    getCurrentUser() {
        //return this.user$.subscribe( x => x?.name);
        this.subscriptions.push(
            this.user$.subscribe(x => {return x?.name})
        );
    }

    ngOnDestroy(): void {    
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    setTimezone(timezone: TimezoneAppItemOutputDto) {
        this.store.dispatch(CoreActions.setTimezone({ timezone }));
    }

    getAppTimezones() {
        return this.appService.getAppTimezones();
    }

    isIanaIdIntlSupportedTimeZone(ianaId: string) {
        return CoreFacade.intlsupportedZones.indexOf(ianaId) !== -1;
    }
}